(() => {
  'use strict';
  if (window.__csContentInstalled) { document.dispatchEvent(new Event('cs:content:refresh')); return; }
  window.__csContentInstalled = true;
  const active = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mountRotator(element) {
    if (active.has(element)) return;
    const slides = [...element.querySelectorAll('[data-cs-slide]')];
    const controls = element.querySelector('[data-cs-rotator-controls]');
    if (slides.length < 2 || !controls) return;
    const position = element.querySelector('[data-cs-rotator-position]');
    const toggle = element.querySelector('[data-cs-rotation-toggle]');
    const intervalMs = Math.max(5000, Number(element.dataset.csInterval) || 6500);
    let index = 0;
    let timer;
    let userPaused = reducedMotion.matches;
    let hovered = false;
    let focused = false;
    const abort = new AbortController();
    function paint() {
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      if (position) position.textContent = `${index + 1} / ${slides.length}`;
      toggle.hidden = reducedMotion.matches;
      toggle.textContent = userPaused ? 'Spustit střídání' : 'Pozastavit';
      toggle.setAttribute('aria-label', userPaused ? 'Spustit střídání recenzí' : 'Pozastavit střídání recenzí');
    }
    function schedule() {
      clearInterval(timer);
      if (!userPaused && !hovered && !focused && !document.hidden && !reducedMotion.matches) {
        timer = setInterval(() => {
          if (!element.isConnected) { cleanup(); return; }
          index = (index + 1) % slides.length;
          paint();
        }, intervalMs);
      }
    }
    function step(delta) {
      index = (index + delta + slides.length) % slides.length;
      // Manual navigation stops automatic updates until explicitly resumed.
      userPaused = true;
      paint();
      schedule();
    }
    function listen(target, event, handler) { target.addEventListener(event, handler, { signal: abort.signal }); }
    function cleanup() { clearInterval(timer); abort.abort(); active.delete(element); }
    listen(element.querySelector('[data-cs-prev]'), 'click', () => step(-1));
    listen(element.querySelector('[data-cs-next]'), 'click', () => step(1));
    listen(toggle, 'click', () => { userPaused = !userPaused; paint(); schedule(); });
    listen(element, 'mouseenter', () => { hovered = true; schedule(); });
    listen(element, 'mouseleave', () => { hovered = false; schedule(); });
    listen(element, 'focusin', () => { focused = true; schedule(); });
    listen(element, 'focusout', (event) => { focused = element.contains(event.relatedTarget); schedule(); });
    listen(document, 'visibilitychange', schedule);
    listen(reducedMotion, 'change', () => { if (reducedMotion.matches) userPaused = true; paint(); schedule(); });
    controls.hidden = false;
    active.set(element, { cleanup, select(slide) {
      const selected = slides.indexOf(slide);
      if (selected < 0) return;
      index = selected;
      userPaused = true;
      paint();
      schedule();
    } });
    paint();
    schedule();
  }
  function mount(root = document) {
    root.querySelectorAll('[data-cs-rotator]').forEach(mountRotator);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  // Avoid several UGC clips speaking at once. Native video controls stay usable.
  document.addEventListener('play', event => {
    if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('.cs-ugc')) return;
    document.querySelectorAll('.cs-ugc video').forEach(video => {
      if (video !== event.target && !video.paused) video.pause();
    });
  }, true);
  document.addEventListener('cs:content:refresh', () => mount());
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:block:select', event => {
    const question = event.target.closest('.cs-faq__item');
    if (question) question.open = true;
    const slide = event.target.closest('[data-cs-slide]');
    if (!slide) return;
    const entry = active.get(slide.closest('[data-cs-rotator]'));
    if (entry) entry.select(slide);
  });
  document.addEventListener('shopify:section:unload', event => {
    active.forEach((entry, element) => { if (event.target.contains(element)) entry.cleanup(); });
  });
})();
